<template>
  <v-dialog :value="sectionEditor.show" :width="1000" @input="handleClosePopup" :retain-focus="false">
    <div style="background-color: #fff">
      <div class="header-modal">
        <v-card-title class="d-flex justify-space-between align-center" style="padding: 10px 0">
          <span style="color: #0081c7">{{ fields['title'] }}</span>
          <v-btn icon @click="handleClosePopup">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
      </div>
      <v-card-text>
        <div class="mb-2">
          <label class="label-input">Section Name</label>
          <v-text-field v-model="fields['title']" label="Name" />
        </div>
        <div class="mb-6">
          <label class="label-input">Section Background</label>
          <div class="group-item">
            <div>
              <label class="label-input mb-0">Padding </label>
              <v-row>
                <v-col md="4" cols="12">
                  <div class="d-flex align-center">
                    <v-checkbox v-model="fields['topPadding']" label="Top Padding" />
                  </div>
                </v-col>
                <v-col md="4" cols="12">
                  <div class="d-flex align-center">
                    <v-checkbox v-model="fields['bottomPadding']" label="Bottom Padding" />
                  </div>
                </v-col>
              </v-row>
            </div>
            <v-row>
              <v-col md="4" cols="12">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="backgroundColor"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['colors'].backgroundColor"
                    @change="handleChangeBackgroundColor"
                  />
                  <v-text-field v-model="fields['colors'].backgroundColor" label="Background Color" dense />
                  <v-btn @click="handleResetBackgroundColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
              <v-col md="4" cols="12">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="authorNameColor"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['colors'].authorNameColor"
                    @change="handleChangeAuthorNameColor"
                  />
                  <v-text-field v-model="fields['colors'].authorNameColor" label="Author Name Color" dense />
                  <v-btn @click="handleResetAuthorNameColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
              <v-col md="4" cols="12">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="textColor"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['colors'].textColor"
                    @change="handleChangeTextColor"
                  />
                  <v-text-field v-model="fields['colors'].textColor" label="Content Text Color" dense />
                  <v-btn @click="handleResetTextColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
              <v-col md="4" cols="12">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="actionColor"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['colors'].actionColor"
                    @change="handleChangeActionColor"
                  />
                  <v-text-field v-model="fields['colors'].actionColor" label="Action Text Color" dense />
                  <v-btn @click="handleResetActionColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
              <v-col md="4" cols="12">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="textareaBorderColor"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['colors'].textareaBorderColor"
                    @change="handleChangeTextareaBorderColor"
                  />
                  <v-text-field v-model="fields['colors'].textareaBorderColor" label="Input Border Color" dense />
                  <v-btn @click="handleResetTextareaBorderColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
              <v-col md="4" cols="12">
                <div class="d-flex align-center gap-3">
                  <input
                    type="color"
                    name="replyBorderColor"
                    style="width: 40px; height: 40px; margin-right: 12px"
                    :value="fields['colors'].replyBorderColor"
                    @change="handleChangeReplyBorderColor"
                  />
                  <v-text-field v-model="fields['colors'].replyBorderColor" label="Reply Border Color" dense />
                  <v-btn @click="handleResetReplyBorderColor" small text color="primary"> Reset </v-btn>
                </div>
              </v-col>
            </v-row>
          </div>
        </div>
        <div class="mb-6">
          <label class="label-input">Title</label>
          <ckeditor :editor="editor" v-model="fields.socialCommentTitle" :config="editorConfig" />
        </div>
        <div>
          <div class="d-flex justify-space-between align-center mb-2">
            <label class="label-input">Comments ({{ (fields.comments && fields.comments.length) || 0 }})</label>
            <v-btn small text color="primary" @click="handleAddComment()">
              <v-icon size="16">mdi-plus</v-icon>
              <span>Add Comment</span>
            </v-btn>
          </div>
          <v-expansion-panels accordion v-if="fields.comments.length">
            <v-expansion-panel
              v-for="(comment, commentIndex) in fields.comments ? fields.comments : []"
              :key="commentIndex"
            >
              <v-expansion-panel-header>
                <div class="d-flex justify-space-between align-center">
                  <div class="comment-header">
                    <div class="comment-avatar">
                      <img :src="comment && comment.author && comment.author.avatar" alt="" />
                    </div>
                    <div class="comment-content">
                      {{ comment && comment.content }}
                    </div>
                  </div>
                  <v-btn icon @click.stop="handleRemoveComment(commentIndex)">
                    <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                  </v-btn>
                </div>
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <div>
                  <v-text-field class="mt-4" v-model="comment.author.name" label="Author Name" dense />
                  <div class="mb-8">
                    <div>Author Avatar</div>
                    <UploadImage
                      @callback="obj => handleUploadImage(obj, { commentIndex })"
                      :image="{ imageSrc: comment && comment.author && comment.author.avatar }"
                      :height="`100`"
                      :typeUpload="'image'"
                      @callbackDelete="handleRemoveImage({ commentIndex })"
                    />
                  </div>
                  <v-textarea class="mt-4" label="Content" outlined v-model="comment.content"></v-textarea>
                  <v-row class="mb-2">
                    <v-col sm="12" md="6">
                      <v-text-field v-model="comment.likesCount" label="Likes Count" dense />
                    </v-col>
                    <v-col sm="12" md="6">
                      <v-text-field v-model="comment.createdAt" label="Created At" dense />
                    </v-col>
                  </v-row>
                  <div>
                    <div class="d-flex justify-space-between align-center mb-2">
                      <label class="label-input"
                        >Replies ({{ (comment.replies && comment.replies.length) || 0 }})</label
                      >
                      <v-btn small text color="primary" @click="handleAddComment(comment.id)">
                        <v-icon size="16">mdi-plus</v-icon>
                        <span>Add Reply</span>
                      </v-btn>
                    </div>
                    <v-expansion-panels accordion v-if="comment.replies.length">
                      <v-expansion-panel
                        v-for="(reply, replyIndex) in comment.replies ? comment.replies : []"
                        :key="replyIndex"
                      >
                        <v-expansion-panel-header>
                          <div class="d-flex justify-space-between align-center">
                            <div class="comment-header">
                              <div class="comment-avatar">
                                <img :src="reply && reply.author && reply.author.avatar" alt="" />
                              </div>
                              <div class="comment-content">
                                {{ reply && reply.content }}
                              </div>
                            </div>
                            <v-btn icon @click.stop="handleRemoveComment(commentIndex, replyIndex)">
                              <v-icon size="20" color="#ff6c6c">mdi-delete</v-icon>
                            </v-btn>
                          </div>
                        </v-expansion-panel-header>
                        <v-expansion-panel-content>
                          <div>
                            <v-text-field class="mt-4" v-model="reply.author.name" label="Author Name" dense />
                            <div class="mb-8">
                              <div>Author Avatar</div>
                              <UploadImage
                                @callback="obj => handleUploadImage(obj, { commentIndex, replyIndex })"
                                :image="{ imageSrc: reply && reply.author && reply.author.avatar }"
                                :height="`100`"
                                :typeUpload="'image'"
                                @callbackDelete="handleRemoveImage({ commentIndex, replyIndex })"
                              />
                            </div>
                            <v-textarea class="mt-4" label="Content" outlined v-model="reply.content"></v-textarea>
                            <v-row>
                              <v-col sm="12" md="6">
                                <v-text-field v-model="reply.likesCount" label="Likes Count" dense />
                              </v-col>
                              <v-col sm="12" md="6">
                                <v-text-field v-model="reply.createdAt" label="Created At" dense />
                              </v-col>
                            </v-row>
                          </div>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-expansion-panels>
                    <div v-if="!comment.replies.length" class="d-flex justify-center group-item">No replies</div>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <div v-if="!fields.comments.length" class="d-flex justify-center group-item">No comments</div>
        </div>
      </v-card-text>
      <div class="footer-modal">
        <v-card-actions style="padding: 10px 0">
          <v-spacer></v-spacer>
          <v-btn min-width="100" depressed @click="handleClosePopup">Cancel</v-btn>
          <v-btn min-width="100" color="primary" @click="handleSave">Save</v-btn>
        </v-card-actions>
      </div>
    </div>
  </v-dialog>
</template>

<script>
import Editor from 'ckeditor5-custom-build/build/ckeditor';
import { ckeditorConfigFullToolbar } from '@/helpers/editor';
import UploadImage from '@/components/form/uploadFile/UpdateImage.vue';
import { updateHtmlFromData } from '../common/html/update';
import productReviewsJson from '@/assets/json/product-reviews.json';

export default {
  name: 'social-comment-section-editor',
  components: {
    UploadImage,
  },
  props: {
    sectionEditor: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      editor: Editor,
      editorConfig: ckeditorConfigFullToolbar,
      fields: {
        title: '',
        socialCommentTitle: '',
        comments: [
          // example
          // {
          //   id: '',
          //   author: {
          //     name: '',
          //     avatar: '',
          //   },
          //   content: '',
          //   likesCount: '',
          //   replies: [
          //     {
          //       id: '',
          //       author: {
          //         name: '',
          //         avatar: '',
          //       },
          //       content: '',
          //       likesCount: '',
          //       createdAt: '',
          //       parentId: ''
          //     },
          //   ],
          //   createdAt: '',
          // },
        ],
        colors: {
          backgroundColor: '#ffffff',
          textColor: '#000000',
          authorNameColor: '#3b5998',
          actionColor: '#2563eb',
          replyBorderColor: '#9ca3af',
          textareaBorderColor: '#D9D9D9',
        },
        topPadding: true,
        bottomPadding: true,
      },
    };
  },
  mounted() {
    this.fields = {
      ...this.fields,
      ...this.sectionEditor.sectionExtract,
    };
  },
  methods: {
    handleClosePopup() {
      this.$emit('close');
    },
    handleUploadImage(obj, { commentIndex, replyIndex }) {
      const finalUrl = obj.imageSrc;

      if (replyIndex === undefined) {
        this.fields.comments[commentIndex].author.avatar = finalUrl;
        return;
      }

      this.fields.comments[commentIndex].replies[replyIndex].author.avatar = finalUrl;
    },
    handleRemoveImage({ commentIndex, replyIndex }) {
      if (replyIndex === undefined) {
        this.fields.comments[commentIndex].author.avatar = '';
        return;
      }

      this.fields.comments[commentIndex].replies[replyIndex].author.avatar = '';
    },
    handleAddComment(parentId = null) {
      if (!Array.isArray(productReviewsJson) || productReviewsJson.length === 0) {
        return null;
      }

      const randomItem = arr => arr[Math.floor(Math.random() * arr.length)];

      const generateId = () =>
        typeof crypto !== 'undefined' && crypto.randomUUID
          ? crypto.randomUUID()
          : `${Date.now()}-${Math.random()
              .toString(36)
              .slice(2)}`;

      const authorItem = randomItem(productReviewsJson);
      const id = generateId();

      if (parentId) {
        const findCommentIndex = this.fields.comments.findIndex(item => item.id === parentId);
        if (findCommentIndex < -1) return;
        return this.fields.comments[findCommentIndex].replies.push({
          id,
          parentId,
          author: {
            name: authorItem.fullName || '',
            avatar: authorItem.avatar || '',
          },
          content: 'Enter reply content...',
          likesCount: Math.floor(Math.random() * 20),
          createdAt: 'a day ago',
        });
      }

      return this.fields.comments.push({
        id,
        author: {
          name: authorItem.fullName || '',
          avatar: authorItem.avatar || '',
        },
        content: 'Enter comment content...',
        likesCount: Math.floor(Math.random() * 50),
        replies: [],
        createdAt: 'a day ago',
      });
    },
    handleRemoveComment(commentIndex, replyIndex) {
      if (replyIndex === undefined) {
        this.fields.comments = this.fields.comments.filter((_, index) => index !== commentIndex);
        return;
      }
      this.fields.comments[commentIndex].replies = this.fields.comments[commentIndex].replies.filter(
        (_, index) => index !== replyIndex,
      );
    },
    handleChangeBackgroundColor(event) {
      this.fields['colors'].backgroundColor = event.target.value;
    },
    handleResetBackgroundColor() {
      this.fields['colors'].backgroundColor = '#ffffff';
    },
    handleChangeTextColor(event) {
      this.fields['colors'].textColor = event.target.value;
    },
    handleResetTextColor() {
      this.fields['colors'].textColor = '#000000';
    },
    handleChangeBorderColor(event) {
      this.fields['colors'].replyBorderColor = event.target.value;
    },
    handleResetBorderColor() {
      this.fields['colors'].replyBorderColor = '#9ca3af';
    },
    handleChangeAuthorNameColor(event) {
      this.fields['colors'].authorNameColor = event.target.value;
    },
    handleResetAuthorNameColor() {
      this.fields['colors'].authorNameColor = '#3b5998';
    },
    handleChangeActionColor(event) {
      this.fields['colors'].actionColor = event.target.value;
    },
    handleResetActionColor() {
      this.fields['colors'].actionColor = '#2563eb';
    },
    handleChangeReplyBorderColor(event) {
      this.fields['colors'].replyBorderColor = event.target.value;
    },
    handleResetReplyBorderColor() {
      this.fields['colors'].replyBorderColor = '#9ca3af';
    },
    handleChangeTextareaBorderColor(event) {
      this.fields['colors'].textareaBorderColor = event.target.value;
    },
    handleResetTextareaBorderColor() {
      this.fields['colors'].textareaBorderColor = '#D9D9D9';
    },
    handleSave() {
      const updateHtml = updateHtmlFromData.sectionSocialComment(this.sectionEditor.section.html, this.fields);
      this.$emit('update:section', {
        ...this.sectionEditor.section,
        title: this.fields['title'],
        html: updateHtml,
      });
      this.$emit('close');
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .ck-editor__editable {
  min-height: 100px !important;
}
::v-deep .ck-editor__editable_inline {
  min-height: 100px !important;
}
.label-input {
  font-size: 18px !important;
  font-weight: 500;
  color: #000;
  margin-bottom: 10px;
  display: block;
}
.header-modal {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  padding: 0 16px;
  box-shadow: 0px 0px 12px #0000000f;
}
.footer-modal {
  position: sticky;
  padding: 0 16px;
  bottom: 0;
  left: 0;
  z-index: 999;
  background-color: #fff;
  box-shadow: 0px 0px 12px #0000000f;
}

.comment-header {
  display: flex;
  align-items: center;
  gap: 12px;

  .comment-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      position: relative;
      z-index: 2;
    }
  }

  .comment-content {
    flex: 1;
    display: -webkit-box;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    -webkit-line-clamp: 1;
  }
}
.group-item {
  padding: 15px 10px;
  border-radius: 10px;
  border: 1px solid #e0e0e0;
}
</style>
